module.exports = __webpack_public_path__ + "static/media/blue-suit.8a1ad6ae.jpg";